import React, { useState } from 'react';
import { IconSvg } from '../IconSvg';
import './CopyButton.css';

interface CopyButtonProps {
  text: string;
  size?: number;
  className?: string;
}

/**
 * 一个通用的复制按钮组件，带点击反馈
 */
export const CopyButton: React.FC<CopyButtonProps> = ({ text, size = 20, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      if (!text) return;
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('复制失败:', err);
    }
  };

  return (
    <button
      className={`copy-button ${copied ? 'copied' : ''} ${className}`}
      onClick={handleCopy}
      title={copied ? '已复制' : '点击复制内容'}
      aria-label="复制内容"
    >
      <IconSvg
        name={copied ? 'ph:check-bold' : 'mdi:content-copy'}
        width={size}
        height={size}
      />
    </button>
  );
};
